export default "__VITE_ASSET__Rvz6n_an__"